import { useEffect } from 'react';
import { mapMsalToMecontrol } from './util';
import { useMsal } from '@azure/msal-react';
/**
 * Effect hook that updates the commandlist in the MeControl.
 */
export const useMeControlCommandListEffect = (meControlCommandList) => {
    var _a;
    const api = (_a = window === null || window === void 0 ? void 0 : window.MeControl) === null || _a === void 0 ? void 0 : _a.API;
    useEffect(() => {
        if (api) {
            api.setCommands(meControlCommandList);
        }
    }, [meControlCommandList, api]);
};
/**
 * Effect hook that updates the account in the MeControl.
 */
export const useMeControlAccountEffect = () => {
    var _a;
    const { instance } = useMsal();
    const account = instance === null || instance === void 0 ? void 0 : instance.getActiveAccount();
    const isMeControlApiReady = !!((_a = window === null || window === void 0 ? void 0 : window.MeControl) === null || _a === void 0 ? void 0 : _a.API);
    useEffect(() => {
        var _a;
        const accountMeControl = mapMsalToMecontrol(account);
        if (((_a = window.MeControl) === null || _a === void 0 ? void 0 : _a.API) !== undefined) {
            //if the mecontrol is ready, load the user account into it
            window.MeControl.API.setActiveAccount(accountMeControl);
        }
    }, [account, isMeControlApiReady]);
};
